var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 1.33333H1.33333V0H18.6667V1.33333ZM1.34667 3.20267C1.37686 3.05159 1.45845 2.91564 1.57756 2.81792C1.69666 2.72021 1.84594 2.66676 2 2.66667H18C18.1541 2.66676 18.3033 2.72021 18.4224 2.81792C18.5416 2.91564 18.6231 3.05159 18.6533 3.20267L19.9867 9.86933C20.006 9.96602 20.0036 10.0658 19.9798 10.1614C19.9559 10.2571 19.9111 10.3463 19.8486 10.4225C19.7861 10.4988 19.7075 10.5602 19.6184 10.6025C19.5293 10.6447 19.4319 10.6666 19.3333 10.6667H0.666667C0.568073 10.6666 0.470719 10.6447 0.38162 10.6025C0.292521 10.5602 0.213894 10.4988 0.151405 10.4225C0.0889161 10.3463 0.0441202 10.2571 0.0202448 10.1614C-0.00363063 10.0658 -0.00599114 9.96602 0.0133333 9.86933L1.34667 3.20267ZM1.33333 12V18.6667H0V20H20V18.6667H18.6667V12H16V14.6667H4V12H1.33333Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantasy);
export default __webpack_public_path__ + "static/media/fantasy.e4567e9d6ca43b38d62fb41a5703f874.svg";
export { ForwardRef as ReactComponent };